import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { lang, toggle, t } = useI18n();

  const navItems = [
    { to: "/", label: t("nav_home"), key: "home" },
    { to: "/companions", label: t("nav_companions"), key: "companions" },
    { to: "/services", label: t("nav_services"), key: "services" },
    { to: "/blog", label: t("nav_blog"), key: "blog" },
    { to: "/reviews", label: t("nav_reviews"), key: "reviews" },
    { to: "/contact", label: t("nav_contact"), key: "contact" },
  ];

  return (
    <header
      className="glass-nav fixed top-0 inset-x-0 z-50"
      data-testid="main-navbar"
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-12 py-5">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex flex-col items-start leading-none"
          onClick={() => setOpen(false)}
        >
          <span className="label-luxury text-[0.55rem]">ESCORT · ATHENS · 18+</span>
          <span className="font-serif-display text-xl md:text-[1.5rem] tracking-[0.18em] uppercase mt-1.5 companion-name-luxury gold-glow font-semibold">
            Bilion&nbsp;Euro&nbsp;Babies
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {navItems.map((n) => (
            <NavLink
              key={n.key}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-link-${n.key}`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.3em] transition-colors hover-gold ${
                  isActive ? "text-[var(--gold)]" : "text-white/70"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <button
            data-testid="lang-toggle"
            onClick={toggle}
            className="text-xs uppercase tracking-[0.3em] text-white/70 hover-gold border border-white/15 px-3 py-2 hover:border-[var(--gold)]/60"
            aria-label="Toggle language"
          >
            {lang === "en" ? "EN / ΕΛ" : "ΕΛ / EN"}
          </button>
          <button
            data-testid="nav-book-btn"
            onClick={() => navigate("/contact")}
            className="btn-gold py-3 px-6 text-[0.7rem]"
          >
            {t("nav_book")}
          </button>
        </div>

        <div className="lg:hidden flex items-center gap-3">
          <button
            data-testid="lang-toggle-mobile"
            onClick={toggle}
            className="text-[0.65rem] uppercase tracking-[0.25em] text-white/80 border border-white/15 px-2.5 py-1.5"
          >
            {lang === "en" ? "EN" : "ΕΛ"}
          </button>
          <button
            className="text-white"
            onClick={() => setOpen((o) => !o)}
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-black/95 border-t border-white/5 px-6 py-8">
          <nav className="flex flex-col gap-6">
            {navItems.map((n) => (
              <NavLink
                key={n.key}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.key}`}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.3em] ${
                    isActive ? "text-[var(--gold)]" : "text-white/80"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <button
              data-testid="mobile-nav-book"
              onClick={() => {
                setOpen(false);
                navigate("/contact");
              }}
              className="btn-gold btn-gold-solid mt-4"
            >
              {t("nav_book")}
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
